"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  en: {
    sprinxFormsValidation: {
      required: 'Is required!',
      string: 'Must be a string!',
      stringEmpty: 'Must not be empty!',
      stringMin: 'Length must be greater than or equal to {expected} characters long!',
      stringMax: 'Length must be less than or equal to {expected} characters long!',
      stringLength: 'Length must be {expected} characters long!',
      stringPattern: 'Fails to match the required pattern!',
      stringContains: "Must contain the '{expected}' text!",
      stringEnum: 'Does not match any of the allowed values!',
      number: 'Must be a number!',
      numberMin: 'Must be greater than or equal to {expected}!',
      numberMax: 'Must be less than or equal to {expected}!',
      numberEqual: 'Must be equal with {expected}!',
      numberNotEqual: "Can't be equal with {expected}!",
      numberInteger: 'Must be an integer!',
      numberPositive: 'Must be a positive number!',
      numberNegative: 'Must be a negative number!',
      array: 'Must be an array!',
      arrayEmpty: 'Must be not an empty array!',
      arrayMin: 'At least {expected, plural, one {1 item} other {{expected} items}} required.',
      arrayMax: "Can't contain more then {expected, plural, one {1 item} other {{expected} items}}.",
      arrayLength: 'Must contain {expected, plural, one {1 item} other {{expected} items}}!',
      arrayContains: "Must contain the '{expected}' item!",
      arrayEnum: "Value '{expected}' does not match any of the allowed values!",
      boolean: 'Must be a boolean!',
      function: 'Must be a function!',
      date: 'Must be a Date!',
      dateMin: 'Must be greater than or equal to {expected}!',
      dateMax: 'Must be less than or equal to {expected}!',
      forbidden: 'Is forbidden!',
      email: 'Not valid e-mail!',
      url: 'Not valid URL!',
      object: 'Must be an Object!',
      arrayReducedEquals: "Reduced value doesn't match {expected}!",
      phoneNumber: "Must be a valid phone number in international format '+XXX XXX XXX XXX'!",
      dateGt: 'Date must be greater than {expected}!',
      dateGte: 'Date must be greater than or equal to {expected}!',
      dateLt: 'Date must be less than {expected}!',
      dateLte: 'Date must be less than or equal to {expected}!'
    }
  }
};
var _default = messages;
exports.default = _default;